import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import AMZMemberDay from '@elem/compCommon/PillarPageActivities/AMZMemberDay';
import A from './components/A';
import css from './index.module.scss';
import EfScrollAni from '@/efscrollani';
import Banner from './v2Components/Banner';
import MillionHomes from './v2Components/MillionHomes';
import Risk from './v2Components/Risk';
import Preparing from './v2Components/Preparing';
import Why from './v2Components/Why';
import Voices from './v2Components/Voices';
import Recommended from './v2Components/Recommended';
import Protection from './v2Components/Protection';
import N from './v2Components/N';
import Reference from './v2Components/Reference';
import 'elem/compPage/battery-backup-for-home/scroll-animation-v2/animations.scss';
import ForumEntry from '@elem/compCommon/CommunityEntry';
// import PDBar from '@elem/compCommon/PDBar';

const IndexDynamic = dynamic(() => import('./indexdynamic'), { ssr: true });

export default function BatteryBackupForHome() {
    const { locale } = useRouter();
    if (typeof window !== 'undefined' && !window.AniContainer) {
        window.AniContainer = new EfScrollAni();
    }

    if (locale === 'us') {
        return (
            <div className={`power-backup ${css['power-backup']}`}>
                {/* <PDBar /> */}
                <Banner />
                <MillionHomes />
                <Risk />
                <Preparing />
                <Why />
                <Voices />
                <Recommended />
                <Protection />
                <N />
                <Reference />
                <ForumEntry />
            </div>
        );
    }
    return (
        <div className={`power-backup ${css['power-backup']}`}>
            <A />
            {['us', 'ca'].includes(locale as string) && <AMZMemberDay />}
            <IndexDynamic />
            <style jsx global>
                {`
                    .ecoflow-header {
                        max-width: 100%;
                    }
                    .footer {
                        max-width: 100%;
                        overflow: hidden;
                    }
                `}
            </style>
        </div>
    );
}
